import { CreatePatient, GetHomeInfo, Login, SyncSession } from "@/app/useCases";
import { EFirebaseCustomEventName, sendEvent } from "@/firebaseinit";
import { toSessionUser } from "@/app/formatters/session";
import { sessionClient } from "./api";
import { authRepo, userRepo } from "./repositories";
import { userDataSource } from "./datasources";
import { appointmentMapper, userMapper } from "./mappers";

// o app guarda o usuário da API no formato de sessão (toSessionUser), não o UserPatient do core.
// Como o legado: se falhar, devolve null e a sessão atual fica como está.
const loadSession = async (id: number) => {
  try {
    return toSessionUser(await userDataSource.getUserById(id));
  } catch (e) {
    console.error("loadSession", e);
    return null;
  }
};

export const login = new Login(authRepo, sessionClient, loadSession);
export const syncSession = new SyncSession(sessionClient, loadSession);

export const createPatient = new CreatePatient(userRepo, login, (userId) =>
  sendEvent({ name: EFirebaseCustomEventName.new_registration, data: { user_id: userId } }),
);

export const getHomeInfo = new GetHomeInfo(userDataSource, appointmentMapper, userMapper);

export const useCases = {
  login,
  createPatient,
  syncSession,
  getHomeInfo,
};
